export const MobilePhoneFieldData = {
  formControlName: 'mobilePhone',
  id: 'grit-field-mobile-phone',
  type: 'tel',
  label: 'Mobile phone',

  mask: 'phone',
  prefixIcon: {
    iconName: 'phone_iphone',
  },
  validationList: [
    {
      errorKey: 'pattern',
      args: ['^[0-9]{3}\\-[0-9]{3}\\-[0-9]{4}$'],
      message: 'Your mobile phone must have 10 digits.',
    },
  ],
  requiredMessage: 'Your mobile phone is required to process the application.',
  hint: 'This helps us verify your account and keep it safe.',
};
